<!--
 * @Description: 登记交底信息
 * @Author: wangwangwang
 * @Date: 2020-08-18 14:50:48
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-10 11:14:12
-->
<template>
  <section>
    <el-dialog v-dialogDrag :visible.sync="visible" width="1120px" :before-close="handleClose" :close-on-click-modal="false">
      <div slot="title" class="dialog-title" style="font-size: 24px; padding-top: 20px; text-align: center">登记交底信息</div>
      <div  v-loading="dialogLoading" element-loading-text="正在加载数据，请稍候..." class="dialoginfo">
        <div class="dialoginfo-title">
          <div :class="type == 0 ? 'active' : 'none'" @click="type = 0">
            <div>销售信息</div>
          </div>
          <!-- <div v-if="ButtonList.findIndex(res => (res.buttonValue == 'CWXX')) !== -1" :class="type == 1 ? 'active' : 'none'" @click="type = 1">
            <div>财务信息</div>
          </div> -->
          <div v-if="updata" :class="type == 2 ? 'active' : 'none'" @click="type = 2">
            <div>生产信息</div>
          </div>
        </div>
        <div v-if="!disabled" class="reference-project-box" >
          <div class="custom-form-item">
            <span class="custom-label">选择引用工程</span>
            <div class="custom-content">
              <el-select 
                v-model="referencedProjectId" 
                placeholder="请输入工程名称搜索引用" 
                clearable 
                filterable
                remote
                default-first-option
                :remote-method="remoteSearchReference"
                :loading="referenceLoading"
                @change="handleReferenceChange"
                @focus="remoteSearchReference('')"
                @clear="clearReference"
              >
                <el-option 
                 v-for="item in referenceProjectList" 
                 :key="item.id"         
                 :label="item.name"     
                 :value="item.id"       
>               </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="dialoginfo-info">
          <el-form ref="projectForm" :model="projectForm" :disabled="disabled" label-width="160px" label-position="right" hide-required-asterisk>
            <!-- 销售信息 -->
            <div v-show="type === 0">
              <div class="form-title">
                <div>基本工程信息</div>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">交底类型</span>
                    <el-select v-model="projectForm.discloseType" placeholder="请选择">
                      <el-option label="委托交底" :value="1"></el-option>
                      <el-option label="合同交底" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">工程名称</span>
                    <el-input v-model="projectForm.enginnerrName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="enginnerrNatureId">
                    <span slot="label" style="color: #ff0000">工程性质</span>
                    <el-select ref="enginnerrNature" v-model="projectForm.enginnerrNatureId" placeholder="请选择" @change="getLabel('enginnerrNature')">
                      <el-option v-for="(item, index) in enginnerrNatureIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">工程地址</span>
                    <el-input v-model="projectForm.enginnerrAddress"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">行政区</span>
                    <el-cascader ref="administratively" v-model="projectForm.administrativeDistrictsId0" style="width: 390px" :options="treeData" filterable @change="getAdministratively"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col v-show="projectForm.discloseType == 1" :span="12" >
                  <el-form-item prop="delegationTypeId">
                    <span slot="label" style="color: #ff0000">委托类型</span> 
                    <el-select ref="delegationType" v-model="projectForm.delegationTypeId" placeholder="请选择"  :disabled="!allowEditDelegationType"  @change="getLabel('delegationType')">
                      <el-option v-for="(item, index) in delegationTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">往来协作</span>
                    <el-select :key="projectForm.collaborationType" v-model="projectForm.collaborationType" placeholder="请选择">
                      <el-option label="非往来协作" :value="1"></el-option>
                      <el-option label="外协" :value="2"></el-option>
                      <el-option label="协外" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同签订主体</span>
                    <el-select ref="collaborationUnitName" v-model="projectForm.collaborationUnit" placeholder="请选择" @change="getLabel('collaborationUnitName')">
                      <el-option v-for="item in roadWorkList2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">区域项目</span>
                    <el-select ref="regionalProjects" v-model="projectForm.regionalProjects" placeholder="请选择">
                      <el-option :key="0" label="否" :value="0"></el-option>
                      <el-option :key="1" label="是" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="150px">
                    <span slot="label" style="color: #ff0000">工程现场特性描述</span>
                    <el-input v-model="projectForm.enginnerrLiveDescription"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="150px">
                    <span slot="label" style="color: #ff0000">是否主工程</span>
                    <el-radio-group v-model="projectForm.isMainEngineering">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                        <el-form-item label-width="150px">
                          <span slot="label" style="color: #ff0000">是否贸易</span>
                          <el-radio-group v-model="projectForm.wetherTrade">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="150px">
                    <span slot="label" style="color: #ff0000">合同单位类型</span>
                    <el-select v-model="projectForm.roadworkType" placeholder="请选择" clearable>
                      <el-option :key="1" label="建设单位" :value="1"></el-option>
                      <el-option :key="2" label="施工单位" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="施工单位">
                    <span slot="label" style="color: #ff0000">施工单位</span>
                    <el-select
                      ref="constructionCompanyId"
                      v-model="projectForm.constructionCompanyId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="
                        $nextTick(() => {
                          projectForm.constructionCompany = $refs.constructionCompanyId.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="建设单位">
                    <span slot="label" style="color: #ff0000">建设单位</span>
                    <el-select
                      ref="constructionUnitId"
                      v-model="projectForm.constructionUnitId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="
                        $nextTick(() => {
                          projectForm.constructionUnit = $refs.constructionUnitId.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="小票打印单位">
                    <span slot="label" :style="projectForm.roadworkType == 3 ? 'color: #ff0000' : ''">小票打印单位</span>
                    <el-select
                      ref="otherUnitId"
                      v-model="projectForm.otherUnitId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="
                        $nextTick(() => {
                          projectForm.otherUnit = $refs.otherUnitId.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="委托单位">
                    <span slot="label" style="color: #ff0000">委托单位</span>
                    <el-input v-model="projectForm.contractCompany"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">内外标识</span>
                    <el-radio-group v-model="projectForm.sidesFlag" @change="handleFlagChange()">
                      <el-radio :label="1">内</el-radio>
                      <el-radio :label="2">外</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col v-if="projectForm.sidesFlag == 1" :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">所属分公司</span>
                    <el-select ref="affiliatedBranchId" v-model="projectForm.affiliatedBranchId" filterable placeholder="请选择"  @change="
                        $nextTick(() => {
                          projectForm.affiliatedBranch = $refs.affiliatedBranchId.selectedLabel;
                        })
                      ">
                      <el-option v-for="item in ExternalSubsidiariesList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">企业性质</span>
                          <el-select ref="businessNature" v-model="projectForm.businessNatureId" filterable
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.businessNature = $refs.businessNature.selectedLabel;
                              })
                              ">
                            <el-option v-for="item in BusinessNatureList" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">协调主体</span>
                    <!-- <el-input v-model="projectForm.coordinateName"></el-input> -->
                    <el-select ref="coordinateNameId" v-model="projectForm.coordinateNameId" filterable placeholder="请选择"  @change="
                        $nextTick(() => {
                          projectForm.coordinateName = $refs.coordinateNameId.selectedLabel;
                        })
                      ">
                      <el-option v-for="item in coordination" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">联营标识</span>
                    <el-select v-model="projectForm.poolFlag" placeholder="请选择">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">协调主体（建材）</span>
                    <!-- <el-input v-model="projectForm.coordinateName"></el-input> -->
                    <el-select ref="coordinationSubjectId" v-model="projectForm.coordinationSubjectId" filterable placeholder="请选择"  @change="
                        $nextTick(() => {
                          projectForm.coordinationSubject = $refs.coordinationSubjectId.selectedLabel;
                        })
                      ">
                      <el-option v-for="item in JCCoordinationBodyList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                      <el-option v-if="showBackupLabel" :value="projectForm.coordinationSubjectId" :label="projectForm.coordinationSubject" disabled />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="projectForm.discloseType == 1">
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">委托期</span>
                    <el-date-picker
                      v-model="projectForm.entrustBeginTImeEntrustEndTime"
                      style="width: 390px"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :disabled="!allowEditDelegationType" 
                      @change="(projectForm.entrustBeginTime = projectForm.entrustBeginTImeEntrustEndTime[0] || ''), (projectForm.entrustEndTime = projectForm.entrustBeginTImeEntrustEndTime[1] || '')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">委托量</span>
                    <el-input
                      v-model="projectForm.entrusNumber"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                      :disabled="!allowEditDelegationType" 
                      @input="projectForm.entrusNumber = $regExp.checkNum(projectForm.entrusNumber)"
                      @blur="projectForm.entrusNumber = $regExp.blurCheckNum(projectForm.entrusNumber)"
                      ><template slot="append">方</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同号</span>
                    <el-input v-model="projectForm.contractNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="施工工期">
                    <span slot="label" style="color: #ff0000">施工工期</span>
                    <el-date-picker
                      v-model="projectForm.constructionStartDateConstructionEndDate"
                      style="width: 390px"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      @change="
                        (projectForm.constructionStartDate = projectForm.constructionStartDateConstructionEndDate[0].slice(0, 10) || ''),
                          (projectForm.constructionEndDate = projectForm.constructionStartDateConstructionEndDate[1].slice(0, 10) || '')
                      "
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">质监备案号</span>
                    <el-input v-model="projectForm.qiRecord"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">登记时间</span>
                    <el-date-picker v-model="projectForm.registerTime" value-format="yyyy-MM-dd" placeholder="选择日期时间" > </el-date-picker>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同单位</span>
                    <el-select
                      ref="businesName"
                      v-model="projectForm.businesNameId"
                      clearable
                      filterable
                      placeholder="请选择"
                      @change="
                        $nextTick(() => {
                          projectForm.businesName = $refs.businesName.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="item in roadWorkList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col v-show="projectForm.discloseType == 2" :span="12">
                  <el-form-item label="合同总量">
                    <span slot="label" style="color: #ff0000">合同总量</span>
                    <el-input v-model="projectForm.contractSumNumber" @blur="projectForm.contractSumNumber = $regExp.blurCheckNum(projectForm.contractSumNumber) || ''"><template slot="append">方</template></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同含税总价">
                    <span slot="label" style="color: #ff0000">合同含税总价</span>
                    <el-input
                      v-model="projectForm.contractPriceOfFax"
                      @input="projectForm.contractPriceOfFax = $regExp.checkNum(projectForm.contractPriceOfFax)"
                      @blur="projectForm.contractPriceOfFax = $regExp.blurCheckNum(projectForm.contractPriceOfFax)"
                      ><template slot="append">元</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="projectForm.discloseType == 2">
                <el-col :span="12">
                  <el-form-item label="超合同供应">
                    <span slot="label" style="color: #ff0000">超合同供应</span>
                    <el-radio-group v-model="projectForm.exceedContractControl">
                      <el-radio :label="0">不允许</el-radio>
                      <el-radio :label="1">允许</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="projectForm.discloseType == 2">
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同生效日期</span>
                    <el-date-picker v-model="projectForm.effectiveDate" value-format="yyyy-MM-dd" placeholder="选择日期时间" > </el-date-picker>
                    <!-- <el-date-picker v-model="projectForm.effectiveDate" type="month" value-format="yyyy-MM" placeholder="选择日期时间"  style="width: 390px"> </el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同有效期</span>
                    <el-date-picker
                      v-model="projectForm.firstIndateEndIndate"
                      style="width: 390px"
                      type="monthrange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      value-format="yyyy-MM"
                      end-placeholder="结束日期"
                      @change="(projectForm.firstIndate = projectForm.firstIndateEndIndate[0] || ''), (projectForm.endIndate = projectForm.firstIndateEndIndate[1] || '')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">合同模式</span>
                    <el-select :key="projectForm.modelOfContract" v-model="projectForm.modelOfContract" placeholder="请选择">
                      <el-option label="包干" :value="1"></el-option>
                      <el-option label="代工" :value="2"></el-option>
                      <el-option label="其他" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">结构类型</span>
                    <el-select
                      ref="structuralTypeId"
                      v-model="projectForm.structuralTypeId"
                      placeholder="请选择"
                      filterable
                      clearable
                      @change="
                        $nextTick(() => {
                          projectForm.structuralTypeName = $refs.structuralTypeId.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in structuralTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">预算员</span>
                    <el-select
                      ref="budgetPerson"
                      v-model="projectForm.budgetPersonId"
                      :disabled="handleType == 3"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="
                        $nextTick(() => {
                          projectForm.budgetPerson = $refs.budgetPerson.selectedLabel;
                        }),
                          changePhone(projectForm.budgetPersonId, 'budgetPerson')
                      "
                    >
                      <el-option v-for="(item, k) in budgetPersonIdList" :key="k" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">预算员处别</span>
                    <el-select
                      ref="formSelect"
                      v-model="projectForm.buseftPlaceTypeId"
                      placeholder="请选择"
                      @change="
                        $nextTick(() => {
                          projectForm.buseftPlaceType = $refs.formSelect.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in yuSuanTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">销售员</span>
                    <el-select
                      ref="saller"
                      v-model="projectForm.sallerId"
                      :disabled="handleType == 3"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="
                        $nextTick(() => {
                          projectForm.saller = $refs.saller.selectedLabel;
                        }),
                          changePhone(projectForm.sallerId, 'saller')
                      "
                    >
                      <el-option v-for="(item, k) in sallerIdList" :key="k" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">销售员处别</span>
                    <el-select
                      ref="placeType"
                      v-model="projectForm.placeTypeId"
                      placeholder="请选择"
                      @change="
                        $nextTick(() => {
                          projectForm.placeType = $refs.placeType.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in placeTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="160px">
                    <span slot="label" style="color: #ff0000">甲方项目负责人及权限</span>
                    <el-input v-model="projectForm.firstLeader"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">我司合同签字人</span>
                    <el-select
                      ref="ourCompanyCheckPerson"
                      v-model="projectForm.ourCompanyCheckPersonId"
                      filterable
                      placeholder="请选择"
                      @change="
                        $nextTick(() => {
                          projectForm.ourCompanyCheckPerson = $refs.ourCompanyCheckPerson.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="(item, index) in ourCompanyCheckPersonIdList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="甲方有权对量">
                    <span slot="label" style="color: #ff0000">甲方有权对量</span>
                    <el-input v-model="projectForm.richAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">甲方小票签收人</span>
                    <el-input v-model="projectForm.firstPartySigner"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="firstPartyMailbox">
                    <span slot="label" style="color: #ff0000">甲方指定邮箱</span>
                    <el-input v-model="projectForm.firstPartyMailbox"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="secondPartyMailbox">
                    <span slot="label" style="color: #ff0000">乙方指定邮箱</span>
                    <el-input v-model="projectForm.secondPartyMailbox"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">质量约定</span>
                    <el-select v-model="projectForm.qualityAgreementIds" filterable placeholder="请选择" multiple>
                      <el-option v-for="(item, index) in qualityAgreementIdList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="收款方式">
                    <span slot="label" style="color: #ff0000">收款方式</span>
                    <el-select v-model="projectForm.clearingForms" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-option v-for="item in clearingList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">发票类别</span>
                    <el-select v-model="projectForm.invoiceCategory" placeholder="请选择">
                      <el-option label="增值税专用发票" :value="1"></el-option>
                      <el-option label="增值税普通发票" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">税率</span>
                    <el-select v-model="projectForm.taxRate" placeholder="请选择">
                      <el-option label="3%" :value="1"></el-option>
                      <el-option label="13%" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="串换约定">
                    <span slot="label" style="color: #ff0000">串换约定</span>
                    <el-input
                      ref="circulateAgreedInput"
                      v-model="projectForm.circulateAgreed"
                      type="textarea"
                      :rows="inputName == '1' && hideText == false ? '3' : '1'"
                      @focus="displayAll('1')"
                      @blur="showSomeText('1')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="签证约定">
                    <span slot="label" style="color: #ff0000">签证约定</span>
                    <el-input v-model="projectForm.visaAgreed" type="textarea" :rows="inputName == '2' && hideText == false ? '3' : '1'" @focus="displayAll('2')" @blur="showSomeText('2')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="交底备注">
                    <span slot="label" style="color: #ff0000">交底备注</span>
                    <el-input v-model="projectForm.disclosureNotes" type="textarea" :rows="inputName == '3' && hideText == false ? '3' : '1'" @focus="displayAll('3')" @blur="showSomeText('3')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="form-title">产品信息</div>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">强度等级</span>
                    <el-select v-model="projectForm.strengthGradeArr" multiple placeholder="请选择" @remove-tag="removeTag" @change="$forceUpdate()">
                      <el-checkbox v-model="checked1" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll1">全选</el-checkbox>
                      <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id" @click.native="setStrende(item)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性能等级">
                    <span slot="label" style="color: #ff0000">性能等级</span>
                    <el-select v-model="projectForm.performanceRateArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked2" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll2">全选</el-checkbox>
                      <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="材料要求">
                    <span slot="label" style="color: #ff0000">材料要求</span>
                    <el-select v-model="projectForm.materialRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked3" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll3">全选</el-checkbox>
                      <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="特殊要求">
                    <span slot="label" style="color: #ff0000">特殊要求</span>
                    <el-select v-model="projectForm.specialRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked4" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll4">全选</el-checkbox>
                      <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="其他要求">
                    <span slot="label" style="color: #ff0000">其他要求</span>
                    <el-select v-model="projectForm.otherRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked5" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll5">全选</el-checkbox>
                      <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="外加剂要求">
                    <span slot="label" style="color: #ff0000">外加剂要求</span>
                    <el-select v-model="projectForm.admixtureRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked6" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll6">全选</el-checkbox>
                      <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">浇筑方式</span>
                    <el-select v-model="projectForm.pumpTypeArr" multiple placeholder="请选择" @change="$forceUpdate()">
                      <el-checkbox v-model="checked7" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll7">全选</el-checkbox>
                      <el-option v-for="item in pumpTypeList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">小方量约定</span>
                    <el-input v-model="projectForm.smallVolume" type="number">
                      <template slot="append">方/车</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-for="(items, index) in projectForm.bulkDensities" :id="items.key" :key="items.key">
                <el-col :span="12">
                  <el-form-item>
                    <span v-if="index == 0" slot="label" style="color: #ff0000">约定容重</span>
                    <el-select v-model="projectForm.bulkDensities[index].strength" placeholder="请选择" style="width: 25%" @change="$forceUpdate()">
                      <el-option v-for="item in projectForm.strengthGradece" :key="item.id" :label="item.name" :value="item.name" @click.native="setId(item, index)"></el-option>
                    </el-select>
                    <el-input v-model="projectForm.bulkDensities[index].bulkDensity" type="number" style="width: 40%"></el-input>
                    <el-link :disabled="disabled" :underline="false" style="margin-left: 20px; color: #018a46" @click="addWeight">添 加</el-link>
                    <el-link v-if="index != 0" :disabled="disabled" :underline="false" style="margin-left: 20px; color: #018a46" @click="delWeight(index)">删 除</el-link>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">甲供材料</span>
                    <el-radio-group v-model="projectForm.armorForMaterials">
                      <el-radio :label="0">无</el-radio>
                      <el-radio :label="1">有</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="projectForm.armorForMaterials == 1" style="background-color: #f6f8fb; border: 1px dashed #dadada; margin-bottom: 20px; padding-top: 20px; margin-left: 80px">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="80px">
                      <span slot="label" style="color: #ff0000">供应单位</span>
                      <el-input v-model="projectForm.supplyUnit" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="110px">
                      <span slot="label" style="color: #ff0000">联系人</span>
                      <el-input v-model="projectForm.supplyContacts" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="110px">
                      <span slot="label" style="color: #ff0000">联系方式</span>
                      <el-input v-model="projectForm.contactsMode" type="number" style="width: 90%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="projectForm.armorForMaterials == 1">
                <div style="padding-bottom: 10px">
                  <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addItem()">
                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                    添加
                  </el-button>
                </div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="projectForm.list" tooltip-effect="dark">
                  <el-table-column label="甲供材料名称" align="center" width="150">
                    <template slot-scope="scope">
                      <span v-if="scope.row.materials" class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index, scope.row.materialsId)">{{ scope.row.materials }}</span>
                      <span v-else class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index)">选择</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="型号" align="center" prop="specification" width="auto"></el-table-column>
                  <el-table-column label="单方掺量(kg)" align="center">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.mixingAmount" :precision="2" style="width: 100%" :controls="false"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="left" prop="specification" width="100">
                    <template slot-scope="scope">
                      <el-button size="mini" class="bottom_two" @click="deleteItem(scope.$index)">
                        <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="form-title">交底附件</div>
              <div style="padding-left: 50px">
                <div class="form-title">合同相关文件</div>
                <FileComponent fileCode="contractFile2" :disabled="disabled" :files="listFilesa1" @deleteFile="deleteFile1" @uplodeSuccess="uplodeSuccess1" />
              </div>
            </div>
            <!-- 财务信息 -->
            <div v-show="type === 1" style="padding: 0px 130px">
              <div class="form-title">
                <div>财务信息</div>
              </div>
              <div>
                <el-form-item label="建委合同号" label-width="120px">
                  <span slot="label" style="color: #ff0000">财务编码</span>
                  <el-input v-model="projectForm.financialCode" style="width: 250px"></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- 生产信息 -->
            <div v-show="type === 2" style="padding: 0px 80px">
              <div class="form-title">
                <div>生产信息</div>
              </div>
              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item label="建材公司建委号" label-width="150px">
                    <span slot="label">建材公司建委号</span>
                    <el-input v-model="projectForm.ccContractNo" style="width: 250px"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="砼工程公司建委号" label-width="160px">
                    <span slot="label">砼工程公司建委号</span>
                    <el-input v-model="projectForm.concreteContractNo" style="width: 250px"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">主供应站点</span>
                    <el-select
                      ref="selection1"
                      v-model="projectForm.mainSupplySiteId"
                      style="width: 250px"
                      placeholder="请选择"
                      @change="
                        choiseBussinessPoint(type),
                          $nextTick(() => {
                            projectForm.mainSupplySite = $refs.selection1.selectedLabel;
                          })
                      "
                    >
                      <el-option v-for="item in pointIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="辅供应站点">
                    <el-select
                      ref="secondSupplySite"
                      v-model="projectForm.secondSupplySiteId"
                      style="width: 250px"
                      placeholder="请选择"
                      @change="
                        $nextTick(() => {
                          projectForm.secondSupplySite = $refs.secondSupplySite.selectedLabel;
                        })
                      "
                    >
                      <el-option v-for="item in pointIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item>
                    <span slot="label" style="color: #ff0000">主供应站点距离</span>
                    <el-input
                      v-model="projectForm.mainSupplySiteDistence"
                      style="width: 250px"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                      @input="projectForm.mainSupplySiteDistence = $regExp.checkNum(projectForm.mainSupplySiteDistence)"
                      @blur="projectForm.mainSupplySiteDistence = $regExp.blurCheckNum(projectForm.mainSupplySiteDistence)"
                      ><template slot="append">千米</template></el-input
                    >
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item>
                    <span slot="label">增值服务项</span>
                    <span>{{ servicePoint }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-button class="bottom_two" style="margin-left: 25px" @click="choiseBussinessPoint()">更改</el-button>
                </el-col>
              </el-row>
              <el-row>
                
                <!-- <el-col :span="12">
                  <el-form-item label="辅供应站点距离">
                    <el-input
                      v-model="projectForm.secondSupplySiteDistence"
                      style="width: 250px"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                      @input="projectForm.secondSupplySiteDistence = $regExp.checkNum(projectForm.secondSupplySiteDistence)"
                      @blur="projectForm.secondSupplySiteDistence = $regExp.blurCheckNum(projectForm.secondSupplySiteDistence)"
                      ><template slot="append">千米</template></el-input
                    >
                  </el-form-item>
                </el-col> -->
              </el-row>
            </div>
          </el-form>
        </div>
        <div v-if="!disabled" style="color: #ff0000; font-size: 12px; padding-top: 9px">提交审核前，请确认以上交底信息填写完整！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all" style="position: absolute; left: 0px" @click="discloseQueryPageFun(data.id)">修改记录</el-button>
        <el-button class="bottom_all_two" @click="handleClose">取 消</el-button>
        <el-button v-if="!disabled && handleType == 1 && !updata" class="bottom_all" type="primary" @click="handleSave">保 存</el-button>
        <el-button v-if="!disabled && handleType != 3 && !updata" class="bottom_all" type="primary" @click="handleSure">提交审核</el-button>
        <el-button v-if="updata" class="bottom_all" type="primary" @click="handleUpdata">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 管控业务点 -->
    <el-dialog v-dialogDrag :visible.sync="bussinessVisible" width="60%">
      <span slot="title" class="dialog-title">管控业务点</span>
      <el-checkbox-group v-model="buspointids">
        <template v-for="(item, index) in buspointArr">
          <div :key="index" class="checkbox-bg">
            <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
          </div>
        </template>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="bussinessVisible = false">关 闭</el-button>
        <el-button class="bottom_all" @click="handlePoint">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 列表单选 -->
    <el-dialog v-dialogDrag :visible.sync="ListChoiceType" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="原物料名称：">
            <el-input v-model="ListChoicePaging.name" placeholder="原物料名称"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="ListChoicePaging.typeId" placeholder="类型">
              <el-option v-for="item in typelist" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="ListChoicePagingFun">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="ListChoiceData"
          tooltip-effect="dark"
          highlight-current-row
          @row-click="ListChoiceFun"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="ListChoiceRadio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="原物料ID" width="170" align="center"></el-table-column>
          <el-table-column prop="barCode" label="原物料编码" width="190" align="center"></el-table-column>
          <el-table-column prop="name" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="auto" align="center"></el-table-column>
          <el-table-column prop="enable" label="状态" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
              <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="ListChoicePaging.page"
          :page-size="ListChoicePaging.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="ListChoicePaging.total"
          @current-change="ListChoicePagingFun(true)"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ListChoiceType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更改记录列表 -->
    <el-dialog v-dialogDrag :visible.sync="lookType" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">更改记录列表</span>
      <div class="dialogOtherinfo">
        <el-table ref="table11Refs" height="400" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="listArr" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="createUserName" label="更改人" width="auto" align="center"></el-table-column>
          <el-table-column prop="createTime" label="更新时间" width="auto" align="center"></el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ modifyPage.total }}条</div>
            <el-pagination :current-page.sync="modifyPage.page" :page-size="modifyPage.pageSize" layout="prev, pager, next, jumper" :total="modifyPage.total" @current-change="discloseQueryPageFun()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="contractQueryPageContractLogFun()">刷新</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="lookType = false">关 闭</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import treeData from "@/views/platform/ICPS/basicConfig/address.js";
import FileComponent from "./fileComponent";
import { saveOrUpdateDisclose, updateDisclose, getDisClostDetail, getManagement, rawMaterialsQueryPage, discloseQueryPage, validateParameters} from "@/api/internetSales/projectClarifi.js";
import { queryProcesses } from "@/api/basicConfig/proflow.js";
import { getDicType, getListByTypeId, getDicsType, getStationByCompanyId } from "@/api/common.js";
import { queryAllByCompanyId, getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
import { getLists } from "@/api/smart/schedul/c.js";
import { queryPage as getUserData } from "@/api/basedata/user";
import { setTimeout } from "timers";
import { get_simple_user_listBycompanyId } from "@/api/GHnumber/contract";
import { getUserInfo } from "@/utils/auth.js";
import { engineeringManagementQueryPage,} from "@/api/smart/schedul/d.js";
export default {
  components: { FileComponent },
  props: ["visible", "data", "disabled", "handleType", "updata", "coordination","allowEditDelegationType",],
  mixins: [mixin],
  data() {
    return {
      inputName: null,
      hideText: true,
      typelist: [],
      queryForm: {},
      treeData,
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      UserInfo: "",
      administrativeDistrictsPlaceholder: [],
      companylist: [],
      type: 0,
      clearingList: [
        {
          name: "银行现金转账",
          id: "1",
        },
        {
          name: "银行承兑汇票",
          id: "2",
        },
        {
          name: "商业承兑汇票",
          id: "3",
        },
        {
          name: "供应链金融产品",
          id: "4",
        },
        {
          name: "其他",
          id: "5",
        },
      ],
      bulkDensitiesDel: [], //删除容重
      referencedProjectId: "",
      referenceLoading: false,      // 新增：远程搜索加载动画控制
      referenceProjectList: [],     // 新增：存放交底分页工程下拉列表
      projectForm: {
        // 基础信息
        delegationTypeId:"",
        delegationType:"",
        engineeringId: "",
        discloseType: "",
        enginnerrName: "",
        enginnerrNature: "",
        enginnerrNatureId: "",
        enginnerrAddress: "",
        administrativeDistrictsId: "",
        administrativeDistrictsId0: "",
        administrativeDistrictsName: "",
        poolFlag: "",
        sidesFlagType: "",
        sidesFlag: 1,
        coordinateName: "",
        coordinateNameId:"",
        enginnerrLiveDescription: "",
        isMainEngineering:"",
        roadworkType: "",
        constructionUnit: "",
        constructionUnitId: "",
        otherUnit: "",
        otherUnitId: "",
        constructionCompany: "",
        constructionCompanyId: "",
        contractCompanyId: "",
        contractCompany: "",
        entrustBeginTImeEntrustEndTime: [],
        bulkDensities: [
          {
            strength: "",
            strengthId: "",
            bulkDensity: "",
          },
        ], //容重
        supplyUnit: "", //供应单位
        supplyContacts: "", //联系人
        contactsMode: "", //联系方式
        entrustBeginTime: "",
        entrustEndTime: "",
        entrusNumber: "",
        contractNo: "",
        contractPriceOfFax: "",
        exceedContractControl: 0, // 超合同供应 (0关闭 1开启)
        constructionStartDateConstructionEndDate: [],
        constructionStartDate: "",
        constructionEndDate: "",
        qiRecord: "",
        registerTime: "",
        firstIndateEndIndate: [],
        firstIndate: "",
        endIndate: "",
        modelOfContract: "",
        budgetPersonId: "",
        budgetPerson: "",
        budgetPersonDepartmentId: "",
        saller: "",
        sallerId: "",
        placeType: "",
        placeTypeId: "",
        buseftPlaceTypeId: "",
        buseftPlaceType: "",
        firstLeader: "",
        ourCompanyCheckPerson: "",
        ourCompanyCheckPersonId: "",
        richAmount: "",
        firstPartySigner: "",
        firstPartyMailbox: "",
        secondPartyMailbox: "",
        qualityAgreementId: "",
        qualityAgreementIds: [],
        clearingForm: [],
        clearingForms: [],
        circulateAgreed: "",
        visaAgreed: "",
        disclosureNotes: "",
        strengthGrade: "", //强度等级
        strengthGradeArr: [], //强度等级
        strengthGradece: [], //容重下拉框
        performanceRate: "", //性能等级
        performanceRateArr: [], //性能等级
        materialRequirements: "", //材料要求
        materialRequirementsArr: [], //材料要求
        specialRequirements: "", //特殊要求
        specialRequirementsArr: [], //特殊要求
        otherRequirements: "", //其他要求
        otherRequirementsArr: [], //其他要求
        admixtureRequirements: "", //外加剂要求
        admixtureRequirementsArr: [], //外加剂要求
        pumpType: "", //泵送方式
        pumpTypeArr: [], //泵送方式
        smallVolume: "",
        // unitWeight: "",
        invoiceCategory: "",
        taxRate: "",
        armorForMaterials: "",
        financialCode: "",
        ccContractNo: "",
        concreteContractNo: "",
        mainSupplySiteId: "",
        mainSupplySite: "",
        mainSupplySiteDistence: "",
        secondSupplySite: "",
        secondSupplySiteId: "",
        secondSupplySiteDistence: "",
        list: [], //甲供材料列表
        fileFist: [], //附件
        collaborationType: 1,
        collaborationUnit: "",
        regionalProjects: "",
        coordinationSubject:"",
        coordinationSubjectId:"",
      },
      ListChoiceType: false,
      ListChoiceData: [],
      ListChoiceDataIndex: "", //当前是从第几条数据打开的
      ListChoiceRadio: "", //单选表格选中项
      ListChoiceRadioCopy: "", //当前打开的单选表格选中项
      ListChoiceRadioRow: "", //单选最终选中值
      ListChoicePaging: {
        //单选表格分页
        pageSize: 5,
        page: 1,
        total: 0,
        name: "",
        typeId: "",
      },
      ourCompanyCheckPersonIdList: [], //公司人员
      budgetPersonIdList: [], //预算员
      sallerIdList: [], //销售员
      firstPartySignerIdList: [], //用料签收员
      qualityAgreementIdList: [], //质量约定
      listFilesa1: [],
      listFilesa2: [], //type01都有的
      disAddCosts: [],
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], // 其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pumpTypeList: [], //浇筑方式泵机类型
      enginnerrNatureIdList: [], //工程性质
      delegationTypeList: [], //委托类型
      placeTypeList: [], //处别
      yuSuanTypeList: [], // 预算处别
      contractTypeIdList: [], //合同类型
      pointIdList: [], //主供应站点
      roadWorkList: [], //合同单位
      roadWorkList2: [], // 往来协作单位
      positionList: [], // 岗位列表
      shutdownLogoList: [],
      successCnt: 0,
      fixPosition: [],
      bussinessVisible: false,
      buspointArr: [],
      servicePoint: "",
      buspointids: [],
      lookType: false,
      listArr: [],
      modifyPage: {
        page: 1,
        pageSize: 10,
        total: 0,
        engineeringId: "",
      },
      TreeSelectStypeNumber: 0,
      oldFormData: "",
      structuralTypeList:[],
      ExternalSubsidiariesList:[],
      BusinessNatureList:[],
      JCCoordinationBodyList:[],
      dialogLoading: false, // 新增：控制弹窗内部加载状态
    };
  },
  watch: {
    // visible: {
    //   handler(newData) {
    //     //进入弹窗将删除文件数组置空
    //     this.listFilesa2 = [];
    //     this.projectForm.engineeringId = this.data.id || "我没有找到工程ID";
    //     /*根据公司获取站点*/
    //     getStationByCompanyId({ id: this.data.companyId }).then(res => {
    //       this.pointIdList = res.data.map(v => {
    //         return {
    //           id: v.stationId,
    //           name: v.stationName,
    //         };
    //       });
    //     });
    //     /*我司合同签字人*/
    //     get_simple_user_listBycompanyId({
    //       roleId: "7605679267385344",
    //       orgznizationId: this.data.companyId,
    //     }).then(res => {
    //       this.ourCompanyCheckPersonIdList = res.data;
    //     });
    //     /*获取预算员*/
    //     get_simple_user_listBycompanyId({
    //       roleId: "48d84b503be7484ca1b5c2eade1ff004",
    //       orgznizationId: this.data.companyId,
    //     }).then(res => {
    //       this.budgetPersonIdList = res.data;
    //       // console.log(JSON.parse(JSON.stringify(this.budgetPersonIdList)));
    //     });
    //     /*获取销售员*/
    //     get_simple_user_listBycompanyId({
    //       roleId: "12b2f6ff304148fd89141e9faa9afb96",
    //       orgznizationId: this.data.companyId,
    //     }).then(res => {
    //       this.sallerIdList = res.data;
    //     });
    //     if (newData) {
    //       // 1. 弹窗一打开，立刻开始转圈
    //       this.dialogLoading = true;
    //       this.listFilesa1 = [];
    //       if (this.handleType != 3) {
    //         this.remoteSearchReference(""); 
    //       }
    //       if (this.handleType === 2 || this.handleType === 3) {
    //         // 编辑或查看
    //         this.$nextTick(() => {
    //           this.$refs.projectForm.resetFields();
    //           this.getDetail();
    //         });
    //       } else {
    //         this.$nextTick(() => {
    //           this.$refs.projectForm.resetFields();
    //           this.$data.projectForm = this.$options.data().projectForm;
    //           this.projectForm.discloseType = this.data.executePhase == 4 ? 2 : this.data.executePhase;
    //           this.projectForm.engineeringId = this.data.id;
    //           this.projectForm.enginnerrName = this.data.name;
    //           this.projectForm.enginnerrAddress = this.data.place;
    //           this.projectForm.enginnerrLiveDescription = this.data.remark;
    //           this.projectForm.enginnerrNatureId = this.data.typeId;
    //           this.projectForm.enginnerrNature = this.data.type;
    //           this.projectForm.businesNameId = this.data.roadworkId;
    //           this.projectForm.businesName = this.data.roadwork;
    //           this.projectForm.roadworkType = this.data.roadworkType;
    //           this.projectForm.constructionCompanyId = this.data.contractSigningUnitId;
    //           this.projectForm.constructionCompany = this.data.contractSigningUnit;
    //           this.projectForm.constructionUnitId = this.data.constructionUnitId;
    //           this.projectForm.constructionUnit = this.data.constructionUnit;
    //           this.projectForm.otherUnitId = this.data.otherUnitId;
    //           this.projectForm.otherUnit = this.data.otherUnit;
    //           this.projectForm.saller = this.data.principal;
    //           this.projectForm.sallerId = this.data.principalId;
    //           this.projectForm.placeType = this.data.placeType;
    //           this.projectForm.placeTypeId = this.data.placeTypeId;
    //           this.projectForm.list = this.data.list || [];
    //           this.projectForm.wetherTrade = this.data.wetherTrade || 0;
    //           if (this.data.administrativeDistricts) {
    //             this.projectForm.administrativeDistrictsId0 = JSON.parse(this.data.administrativeDistricts);
    //             this.projectForm.administrativeDistrictsId = this.data.administrativeDistricts;
    //             this.$forceUpdate();
    //           }
    //           if (this.data.beginTime) {
    //             this.projectForm.constructionStartDateConstructionEndDate = [this.data.beginTime, this.data.finishTime];
    //             this.projectForm.constructionStartDate = this.data.beginTime.slice(0, 10);
    //             this.projectForm.constructionEndDate = this.data.finishTime.slice(0, 10);
    //           }
    //           // this.changeBusiness(this.projectForm.businesNameId);
    //           this.servicePoint = "";
    //         });
    //       }
    //     }
    //   },
    // },
    visible: {
      handler(newData) {
        if (newData) {
          // 1. 弹窗打开，开启加载动画
          this.dialogLoading = true;
          this.listFilesa2 = [];
          this.projectForm.engineeringId = this.data.id || "我没有找到工程ID";
          /* 根据公司获取站点 */
          const p1 = getStationByCompanyId({ id: this.data.companyId }).then(res => {
            this.pointIdList = res.data.map(v => {
              return {
                id: v.stationId,
                name: v.stationName,
              };
            });
          });
          /* 我司合同签字人 */
          const p2 = get_simple_user_listBycompanyId({
            roleId: "7605679267385344",
            orgznizationId: this.data.companyId,
          }).then(res => {
            this.ourCompanyCheckPersonIdList = res.data;
          });
          /* 获取预算员 */
          const p3 = get_simple_user_listBycompanyId({
            roleId: "48d84b503be7484ca1b5c2eade1ff004",
            orgznizationId: this.data.companyId,
          }).then(res => {
            this.budgetPersonIdList = res.data;
          });
          /* 获取销售员 */
          const p4 = get_simple_user_listBycompanyId({
            roleId: "12b2f6ff304148fd89141e9faa9afb96",
            orgznizationId: this.data.companyId,
          }).then(res => {
            this.sallerIdList = res.data;
          });
          // 2. Promise 并发请求，全部成功后执行后续逻辑
          Promise.all([p1, p2, p3, p4]).then(() => {
            this.listFilesa1 = [];
            if (this.handleType != 3) {
              this.remoteSearchReference("");
            }
            if (this.handleType === 2 || this.handleType === 3) {
              // 编辑或查看
              this.$nextTick(() => {
                this.$refs.projectForm && this.$refs.projectForm.resetFields();
              });
              // 关键点：return getDetail，这样外层的 finally 会等它查完详情再关闭 Loading
              return this.getDetail(); 
            } else {
              // 新增操作
              this.$nextTick(() => {
                this.$refs.projectForm && this.$refs.projectForm.resetFields();
                this.$data.projectForm = this.$options.data().projectForm;
                this.projectForm.discloseType = this.data.executePhase == 4 ? 2 : this.data.executePhase;
                this.projectForm.engineeringId = this.data.id;
                this.projectForm.enginnerrName = this.data.name;
                this.projectForm.enginnerrAddress = this.data.place;
                this.projectForm.enginnerrLiveDescription = this.data.remark;
                this.projectForm.enginnerrNatureId = this.data.typeId;
                this.projectForm.enginnerrNature = this.data.type;
                this.projectForm.businesNameId = this.data.roadworkId;
                this.projectForm.businesName = this.data.roadwork;
                this.projectForm.roadworkType = this.data.roadworkType;
                this.projectForm.constructionCompanyId = this.data.contractSigningUnitId;
                this.projectForm.constructionCompany = this.data.contractSigningUnit;
                this.projectForm.constructionUnitId = this.data.constructionUnitId;
                this.projectForm.constructionUnit = this.data.constructionUnit;
                this.projectForm.otherUnitId = this.data.otherUnitId;
                this.projectForm.otherUnit = this.data.otherUnit;
                this.projectForm.saller = this.data.principal;
                this.projectForm.sallerId = this.data.principalId;
                this.projectForm.placeType = this.data.placeType;
                this.projectForm.placeTypeId = this.data.placeTypeId;
                this.projectForm.list = this.data.list || [];
                this.projectForm.wetherTrade = this.data.wetherTrade || 0;
                
                if (this.data.administrativeDistricts) {
                  this.projectForm.administrativeDistrictsId0 = JSON.parse(this.data.administrativeDistricts);
                  this.projectForm.administrativeDistrictsId = this.data.administrativeDistricts;
                  this.$forceUpdate();
                }
                if (this.data.beginTime) {
                  this.projectForm.constructionStartDateConstructionEndDate = [this.data.beginTime, this.data.finishTime];
                  this.projectForm.constructionStartDate = this.data.beginTime.slice(0, 10);
                  this.projectForm.constructionEndDate = this.data.finishTime.slice(0, 10);
                }
                this.servicePoint = "";
              });
            }
          }).catch((err) => {
            console.error("初始化数据失败", err);
            this.$message.error('交底信息加载失败，请关闭重试');
          }).finally(() => {
            // 3. 无论所有请求是成功还是报错，最后统一关闭加载动画
            this.dialogLoading = false;
          });
        }
      },
    },
  },
  computed: {
  // 判断当前选中的值在字典里是否存在
  isValueInDict() {
    return this.JCCoordinationBodyList.some(item => item.id === this.projectForm.coordinationSubjectId);
  },

  // 是否显示兜底的禁用选项
  showBackupLabel() {
    return this.projectForm.coordinationSubjectId && !this.isValueInDict;
  }
},
  async created() {
    this.UserInfo = getUserInfo();
    this.treeData.forEach(v => {
      v.children.forEach(res => {
        res.children.forEach(res2 => {
          delete res2.children;
        });
      });
    });
    // 委托类型
    getDicType({ code: "delegation_type" }).then(res => {
      this.delegationTypeList = res.data.items;
    });
    // 类型
    getDicType({ code: "MATtype" }).then(res => {
      this.typelist = res.data.items;
    });
    // 结构类型
    getDicType({ code: "structuralType" }).then(res => {
      this.structuralTypeList = res.data.items;
    });
    // 分公司
    getDicType({ code: "ExternalSubsidiaries" }).then(res => {
      this.ExternalSubsidiariesList = res.data.items;
    });
    // 企业性质
    getDicType({ code: "BusinessNature" }).then(res => {
      this.BusinessNatureList = res.data.items;
    });
    // 协调单位建材
    getDicType({ code: "JCCoordinationBody" }).then(res => {
      this.JCCoordinationBodyList = res.data.items;
    });
    /**质量约定list */
    getDicType({ code: "TheQualityAgreement" }).then(res => {
      if (res.data) {
        this.qualityAgreementIdList = res.data.items; //
        this.qualityAgreementIdList.map(res => (res.name = res.itemName));
      }
    });
    /**浇筑方式泵机类型 */
    getDicType({
      code: "castingType",
    }).then(res => {
      res.data.items.map(v1 => (v1.type = 1));
      this.pumpTypeList = res.data.items;
      getDicType({
        code: "pouringMethod",
      }).then(res => {
        res.data.items.map(v2 => (v2.type = 2));
        this.pumpTypeList = [...this.pumpTypeList, ...res.data.items];
      });
    });
    /**
     * @Description: 获取5大参数
     * @Param:
     * @Author: wangwangwang
     */
    getLists().then(res => {
      res.data.forEach(item => {
        if (!item) return;
        if (item.typeName == "强度等级") {
          this.strengthGradeList = item.list;
        } else if (item.typeName == "规范性能等级") {
          this.performanceGradeList = item.list;
        } else if (item.typeName == "材料要求") {
          this.meterialRequirementsList = item.list;
        } else if (item.typeName == "特殊要求") {
          this.specialRequirementsList = item.list;
        } else if (item.typeName == "外加剂要求") {
          this.admixtureRequirementsList = item.list;
        } else if (item.typeName == "其他要求") {
          this.otherRequirementsList = item.list;
        }
      });
    });
    /**
     * @Description: 获取强度等级
     * @Param:
     * @Author: wangwangwang
     */
    getListByTypeId({
      typeId: 1,
    }).then(res => {
      this.arr1 = res.data;
    });
    /**
     * @Description: 获取数据字典
     * @Param:
     * @Author: wangwangwang
     */
    getDicsType({ codes: "EngineeringNature,contractType,MATname,castingType,shutdownLogo, placeDon, recordFixedPostition, market,YSchubie" }).then(res => {
      if (res.code === 1001) {
        this.enginnerrNatureIdList = res.data.EngineeringNature.items;
        this.contractTypeIdList = res.data.contractType.items;
        this.arr2 = res.data.MATname.items;
        this.shutdownLogoList = res.data.shutdownLogo.items;
        this.placeTypeList = res.data.placeDon.items;
        this.yuSuanTypeList = res.data.YSchubie.items;
        this.fixPosition = res.data.recordFixedPostition.items;
        this.buspointArr = res.data.market.items;
      }
    });
    /**
     * @Description: 获取施工单位
     * @Param:
     * @Author: wangwangwang
     */
    queryAllByCompanyId().then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList2 = res.data;
      }
    });
  },
  methods: {
    remoteSearchReference(query) {
      const params = {
        isAssess: 4,
        status: "4",
        name: query || "", 
        page: 1,
        pageSize: 100
      };
      
      this.referenceLoading = true;
      engineeringManagementQueryPage(params).then(res => {
        if (res.code === 1001 && res.data) {
          this.referenceProjectList = res.data.data || [];
        } else {
          this.referenceProjectList = [];
        }
      }).catch(() => {
        this.referenceProjectList = [];
      }).finally(() => {
        this.referenceLoading = false; // 关闭加载中
      });
    },
    /**
     * 🌟 2. 选中引用的工程后的回调（仿照原本修改/查看时的回显方法）
     * @param {String} val 选中的工程ID
     */
    handleReferenceChange(val) {
      if (!val) {
        this.clearReference();
        return;
      }
      // 仿照原本编辑回显时调用的 getDisClostDetail 接口获取该工程详情
      getDisClostDetail({ id: val }).then(res => {
        if (res.code === 1001 && res.data) {
          // this.projectForm = { ...this.projectForm, ...res.data };
         // 1. 浅拷贝一份引用数据
          const referenceData = { ...res.data };
          // 2. 删掉不需要覆盖的字段
          delete referenceData.engineeringId;
          delete referenceData.enginnerrName;
          delete referenceData.id;
          // 3. 将清理过的数据合并到响应式表单中
          this.projectForm = { ...this.projectForm, ...referenceData };
          // 仿照原 getDetail 内部的联动解析逻辑
          if (this.projectForm.administrativeDistrictsId) {
            this.projectForm.administrativeDistrictsId0 = JSON.parse(this.projectForm.administrativeDistrictsId);
          }
          if (this.projectForm.strengthGrade) {
            this.projectForm.strengthGradeArr = JSON.parse(this.projectForm.strengthGrade)?.map(v => v.id);
            this.projectForm.strengthGradece = JSON.parse(this.projectForm.strengthGrade);
          }
          if (this.projectForm.performanceRate) {
            this.projectForm.performanceRateArr = JSON.parse(this.projectForm.performanceRate)?.map(v => v.id);
          }
          if (this.projectForm.materialRequirements) {
            this.projectForm.materialRequirementsArr = JSON.parse(this.projectForm.materialRequirements)?.map(v => v.id);
          }
          if (this.projectForm.specialRequirements) {
            this.projectForm.specialRequirementsArr = JSON.parse(this.projectForm.specialRequirements)?.map(v => v.id);
          }
          if (this.projectForm.otherRequirements) {
            this.projectForm.otherRequirementsArr = JSON.parse(this.projectForm.otherRequirements)?.map(v => v.id);
          }
          if (this.projectForm.admixtureRequirements) {
            this.projectForm.admixtureRequirementsArr = JSON.parse(this.projectForm.admixtureRequirements)?.map(v => v.id);
          }
          if (this.projectForm.pumpType) {
            const pumpType = JSON.parse(this.projectForm.pumpType);
            const arr = [];
            for (let i = 0; i < this.pumpTypeList.length; i++) {
              for (let j = 0; j < pumpType.length; j++) {
                if (pumpType[j].id === this.pumpTypeList[i].id) {
                  arr.push(pumpType[j].id);
                }
              }
            }
            this.projectForm.pumpTypeArr = arr;
          }
          if (this.projectForm.entrustBeginTime) {
            this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
          }
          if (this.projectForm.clearingForm) {
            this.projectForm.clearingForms = this.projectForm.clearingForm.split(",");
          }
          if (this.projectForm.qualityAgreementId) {
            this.projectForm.qualityAgreementIds = this.projectForm.qualityAgreementId.split(",");
          }
          if (this.projectForm.constructionStartDate) {
            this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
          }

          this.projectForm.list = res.data.list || [];
          const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
          this.oldFormData = JSON.parse(JSON.stringify(this.projectForm));
          const copyData = newData.filter(item => item.type == 1);
          this.servicePoint = copyData.map(item => item.name).join(",");
          //合同回显组装
          const Arry1 = [];
          for (let i = 0; i < res.data.fileFist?.length; i += 1) {
            if (res.data.fileFist[i].fileType === "1") {
              const data = {
                name: res.data.fileFist[i].fileName,
                fileName: res.data.fileFist[i].fileName,
                fileUrl: res.data.fileFist[i].path,
                path: res.data.fileFist[i].path,
                fileType: 1,
                createTime: res.data.fileFist[i].createTime,
                type: 1,
                id: res.data.fileFist[i].id,
              };
              Arry1.push(data);
            }
          }
          this.listFilesa1 = Arry1;
          if (this.projectForm.bulkDensities.length == 0) {
            this.projectForm.bulkDensities = [{ bulkDensity: "", strength: "", strengthId: "", type: "" }];
          }
          getManagement({ id: val }).then(res => {
            if (res.data) {
              res.data.validityOfDelegationId *= 1;
              res.data.reportLogoId *= 1;
            }
            this.projectForm.riskInfo = res.data || {};
          });
              this.$message.success("已成功引用并复现该工程交底信息");
            }
          });
    },
    /**
     * 清空选择器时恢复基础表单项
     */
    clearReference() {
      this.referencedProjectId = "";
      this.referenceProjectList = [];
    },
    handleFlagChange() {
      this.projectForm.affiliatedBranchId = '';
      this.projectForm.affiliatedBranch='';
        if(this.projectForm.sidesFlag == 1) {
          this.projectForm.coordinationSubject = ""
          this.projectForm.coordinationSubjectId = ""
        }
        if(this.projectForm.sidesFlag == 2) {
          if(this.projectForm.roadworkType == 1){
            this.projectForm.coordinationSubject = this.projectForm.constructionUnit 
            this.projectForm.coordinationSubjectId = this.projectForm.constructionUnitId
          }
          if(this.projectForm.roadworkType == 2){
            this.projectForm.coordinationSubject = this.projectForm. constructionCompany 
            this.projectForm.coordinationSubjectId = this.projectForm.constructionCompanyId
          }
        }
      },
    //添加容重
    addWeight() {
      this.projectForm.bulkDensities.push({
        bulkDensity: "",
        strength: "",
        strengthId: "",
        type: 1, //添加1 修改2 删除0
      });
    },
    delWeight(index) {
      var removeBulk = this.projectForm.bulkDensities.splice(index, 1);
      if (removeBulk[0].id) {
        removeBulk[0].type = 0;
        this.bulkDensitiesDel.push(removeBulk[0]);
      }
    },
    removeTag(item) {
      this.projectForm.strengthGradece.forEach((m, n) => {
        if (item == m.id) {
          this.projectForm.strengthGradece.splice(n, 1);
        }
      });
      this.projectForm.bulkDensities.forEach((items, index) => {
        if (item == items.strengthId) {
          this.delWeight(index);
          if (this.projectForm.bulkDensities.length == 0) {
            this.projectForm.bulkDensities = [
              {
                bulkDensity: "",
                strength: "",
                strengthId: "",
                type: 1, //添加1 修改2 删除0
              },
            ];
          }
          this.$forceUpdate();
        }
      });
    },
    setId(item, index) {
      if (!this.projectForm.bulkDensities[index].id) {
        this.projectForm.bulkDensities[index].type = 1;
      } else {
        this.projectForm.bulkDensities[index].type = 2;
      }
      this.projectForm.bulkDensities[index].strengthId = item.id;
    },
    setStrende(item) {
      this.projectForm.strengthGradece.push(item);
      this.$forceUpdate();
    },
    showSomeText(str) {
      if (str == "1") {
        this.inputName = null;
        this.hideText = true;
      } else if (str == "2") {
        this.inputName = null;
        this.hideText = true;
      } else if (str == "3") {
        this.inputName = null;
        this.hideText = true;
      }
    },
    displayAll(str) {
      if (str == "1") {
        this.inputName = "1";
        this.hideText = false;
      } else if (str == "2") {
        this.inputName = "2";
        this.hideText = false;
      }
      if (str == "3") {
        this.inputName = "3";
        this.hideText = false;
      }
      console.log(this.$refs.circulateAgreedInput.$attrs.rows);
    },
    // 获取下拉框选中数据的label
    getLabel(key) {
      this.$nextTick(() => {
        this.$set(this.projectForm, key, this.$refs[key].selected.label);
      });
    },
    // 获取行政区具体地址
    getAdministratively() {
      const arr = this.$refs["administratively"].getCheckedNodes()[0].pathLabels;
      this.projectForm.administrativeDistrictsName = JSON.stringify(arr);
    },
    // 工程履约中修改交底信息
    handleUpdata() {
      if (this.chackForm()) {
        if ((!this.projectForm.concreteContractNo || !this.projectForm.ccContractNo || !this.projectForm.mainSupplySiteId) && this.shengchan) {
          this.$message.warning("生产信息存在必填数据未填写");
          return;
        }
        this.saveBaseInfo();
        this.$emit("update:visible", false);
      }
    },
    changeValue(value) {
      if (value < 0) {
        value = 0;
      } else if (value > 50) {
        value = 50;
      } else {
        value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      }
      this.projectForm.smallVolume = value;
    },
    selectAll1() {
      if (this.checked1) {
        this.projectForm.strengthGradeArr = this.strengthGradeList.map(item => item.id);
        this.projectForm.strengthGradece = this.strengthGradeList;
      } else {
        this.projectForm.strengthGradeArr = [];
        this.projectForm.strengthGradece = [];
      }
    },
    selectAll2() {
      if (this.checked2) {
        this.projectForm.performanceRateArr = this.performanceGradeList.map(item => item.id);
      } else {
        this.projectForm.performanceRateArr = [];
      }
    },
    selectAll3() {
      if (this.checked3) {
        this.projectForm.materialRequirementsArr = this.meterialRequirementsList.map(item => item.id);
      } else {
        this.projectForm.materialRequirementsArr = [];
      }
    },
    selectAll4() {
      if (this.checked4) {
        this.projectForm.specialRequirementsArr = this.specialRequirementsList.map(item => item.id);
      } else {
        this.projectForm.specialRequirementsArr = [];
      }
    },
    selectAll5() {
      if (this.checked5) {
        this.projectForm.otherRequirementsArr = this.otherRequirementsList.map(item => item.id);
      } else {
        this.projectForm.otherRequirementsArr = [];
      }
    },
    selectAll6() {
      if (this.checked6) {
        this.projectForm.admixtureRequirementsArr = this.admixtureRequirementsList.map(item => item.id);
      } else {
        this.projectForm.admixtureRequirementsArr = [];
      }
    },
    selectAll7() {
      if (this.checked7) {
        this.projectForm.pumpTypeArr = this.pumpTypeList.map(item => item.id);
      } else {
        this.projectForm.pumpTypeArr = [];
      }
    },
    changeBusiness(value) {
      const newData = this.roadWorkList.find(item => item.id === value);
      /*获取用料签收员*/
      get_simple_user_listBycompanyId({
        roleId: "3e32ac0a1e95449d91d80bd97bd30ec7",
        orgznizationId: newData?.companyId,
      }).then(res => {
        this.firstPartySignerIdList = res.data;
      });
    },
    /**修改记录 */
    discloseQueryPageFun(val) {
      if (val) {
        this.modifyPage.engineeringId = val;
      }
      this.lookType = true;
      discloseQueryPage(this.modifyPage).then(res => {
        this.listArr = res.data.data;
        this.modifyPage.total = res.data.totalRows;
      });
    },
    administrativeDistrictsIdFun() {
      this.projectForm.administrativeDistrictsId = JSON.stringify(this.projectForm.administrativeDistrictsId0);
      this.projectForm.administrativeDistrictsName = this.$refs.address.getCheckedNodes()[0].pathLabels.join("-");
      this.$forceUpdate();
    },
    /**
     * @Description: 选择管控业务点
     * @Param: 通过选中的站点获取默认选中数据
     * @Author: wangwangwang
     */
    choiseBussinessPoint(type) {
      if (!this.projectForm.mainSupplySiteId) {
        this.$message.warning("请选择主供应站点后再进行操作");
        return;
      }
      if (!type) {
        this.bussinessVisible = true;
      }
      queryProcesses({ stationId: this.projectForm.mainSupplySiteId }).then(res => {
        if (res.code === 1001) {
          const newData = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
          const copyData = newData.filter(item => item.type * 1 === 1);
          this.buspointids = copyData.map(item => item.id);
          this.servicePoint = copyData.map(item => item.name).join(",");
          this.projectForm.servicePoint =  res.data.servicePoint
        }
      });
      // 原逻辑
      // if (this.projectForm.servicePoint && !type) {
      //   const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
      //   const copyData = newData.filter(item => item.type * 1 === 1);
      //   this.buspointids = copyData.map(item => item.id);
      // } else {
      //   queryProcesses({ stationId: this.projectForm.mainSupplySiteId }).then(res => {
      //     if (res.code === 1001) {
      //       const newData = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
      //       const copyData = newData.filter(item => item.type * 1 === 1);
      //       this.buspointids = copyData.map(item => item.id);
      //       this.servicePoint = copyData.map(item => item.name).join(",");
      //       this.projectForm.servicePoint =  res.data.servicePoint
      //     }
      //   });
      // }
    },
    handlePoint() {
      const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
      this.servicePoint = newData.map(item => item.itemName).join(",");
      this.projectForm.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
      this.bussinessVisible = false;
    },
    tableRowClassName({ row }) {
      if (row.dataType == 0) {
        return "display-row-Fzy";
      }
      return "";
    },
    /**
     * @Description:  通过岗位查找人员
     * @Param:
     * @Author: wangwangwang
     */
    choisePerson(data) {
      if (!data.postId) {
        this.$message.warning("请先选择角色");
        return;
      }
      const params = {
        roleId: data.postId,
        page: 1,
        pageSize: 100,
      };
      getUserData(params).then(res => {
        if (res.code === 1001) {
          data.list = res.data.data;
          // console.log(data.list);
          this.$forceUpdate();
        }
      });
    },
    /**
     * @Description: 设置电话号码
     * @Param:
     * @Author: wangwangwang
     * @param {*} data
     */
    changePerson(value, data, arr) {
      const newData = arr.filter(item => item.id === value);
      data.phone = newData[0].phoneNum;
      data.name = newData[0].name;
    },
    copy(list) {
      let str = JSON.stringify(list);
      return JSON.parse(str);
    },
    riskInfoValidChange(val) {
      if (val === "1") {
        this.projectForm.riskInfo.validityOfDelegation = "有效";
      } else {
        this.projectForm.riskInfo.validityOfDelegation = "无效";
      }
    },
    riskInfoShutdownChange(val) {
      this.shutdownLogoList.forEach(item => {
        if (item.id === val) {
          this.projectForm.riskInfo.shutdownLogo = item.itemName;
          return;
        }
      });
    },
    /**再次编辑或者审核，重新初始化数据页面,查询详情 */
    // async getDetail() {
    //   const id = this.data.id;
    //   await getDisClostDetail({ id: id }).then(async res => {
    //     if (res.data) {
    //       this.projectForm = { ...this.projectForm, ...res.data };
    //       if (this.projectForm.administrativeDistrictsId) {
    //         this.projectForm.administrativeDistrictsId0 = JSON.parse(this.projectForm.administrativeDistrictsId); //行政区
    //       }
    //       this.projectForm.strengthGradeArr = JSON.parse(this.projectForm.strengthGrade)?.map(v => v.id); //强度等级
    //       this.projectForm.strengthGradece = JSON.parse(this.projectForm.strengthGrade);
    //       // console.log(this.strengthGradece)
    //       if (this.projectForm.performanceRate) {
    //         this.projectForm.performanceRateArr = JSON.parse(this.projectForm.performanceRate)?.map(v => v.id); //性能等级
    //       }
    //       if (this.projectForm.materialRequirements) {
    //         this.projectForm.materialRequirementsArr = JSON.parse(this.projectForm.materialRequirements)?.map(v => v.id); //材料要求
    //       }
    //       if (this.projectForm.specialRequirements) {
    //         this.projectForm.specialRequirementsArr = JSON.parse(this.projectForm.specialRequirements)?.map(v => v.id); //特殊要求
    //       }
    //       if (this.projectForm.otherRequirements) {
    //         this.projectForm.otherRequirementsArr = JSON.parse(this.projectForm.otherRequirements)?.map(v => v.id); //其他要求
    //       }
    //       if (this.projectForm.admixtureRequirements) {
    //         this.projectForm.admixtureRequirementsArr = JSON.parse(this.projectForm.admixtureRequirements)?.map(v => v.id); //外加剂要求
    //       }
    //       if (this.projectForm.pumpType) {
    //         const pumpType = JSON.parse(this.projectForm.pumpType);
    //         const arr = [];
    //         for (let i = 0; i < this.pumpTypeList.length; i++) {
    //           for (let j = 0; j < pumpType.length; j++) {
    //             if (pumpType[j].id === this.pumpTypeList[i].id) {
    //               arr.push(pumpType[j].id);
    //             }
    //           }
    //         }
    //         this.projectForm.pumpTypeArr = arr;
    //         // this.projectForm.pumpTypeArr = JSON.parse(this.projectForm.pumpType) ?.map((v) => v.id)//泵送方式
    //       }
    //       if (this.projectForm.entrustBeginTime) {
    //         this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
    //       }
    //       if (this.projectForm.clearingForm) {
    //         this.projectForm.clearingForms = this.projectForm.clearingForm.split(",");
    //       }
    //       if (this.projectForm.qualityAgreementId) {
    //         this.projectForm.qualityAgreementIds = this.projectForm.qualityAgreementId.split(",");
    //       }
    //       if (this.projectForm.constructionStartDate) {
    //         this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
    //       }
    //       this.projectForm.firstIndateEndIndate = [this.projectForm.firstIndate, this.projectForm.endIndate];
    //       this.projectForm.list = res.data.list || [];
    //       const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
    //       this.oldFormData = JSON.parse(JSON.stringify(this.projectForm));
    //       const copyData = newData.filter(item => item.type == 1);
    //       this.servicePoint = copyData.map(item => item.name).join(",");
    //       //合同回显组装
    //       const Arry1 = [];
    //       for (let i = 0; i < res.data.fileFist?.length; i += 1) {
    //         if (res.data.fileFist[i].fileType === "1") {
    //           const data = {
    //             name: res.data.fileFist[i].fileName,
    //             fileName: res.data.fileFist[i].fileName,
    //             fileUrl: res.data.fileFist[i].path,
    //             path: res.data.fileFist[i].path,
    //             fileType: 1,
    //             createTime: res.data.fileFist[i].createTime,
    //             type: 1,
    //             id: res.data.fileFist[i].id,
    //           };
    //           Arry1.push(data);
    //         }
    //       }
    //       this.listFilesa1 = Arry1;
    //       if (this.projectForm.bulkDensities.length == 0) {
    //         this.projectForm.bulkDensities = [{ bulkDensity: "", strength: "", strengthId: "", type: "" }];
    //       }
    //       // console.log(this.listFilesa1);
    //     }
    //   });
    //   getManagement({ id: id }).then(res => {
    //     if (res.data) {
    //       res.data.validityOfDelegationId *= 1;
    //       res.data.reportLogoId *= 1;
    //     }
    //     this.projectForm.riskInfo = res.data || {};
    //   });
    // },
    /**再次编辑或者审核，重新初始化数据页面,查询详情 */
    getDetail() {
      const id = this.data.id;
      // 请求 1：获取交底详情
      const p1 = getDisClostDetail({ id: id }).then(res => {
        if (res.data) {
          this.projectForm = { ...this.projectForm, ...res.data };
          if (this.projectForm.administrativeDistrictsId) {
            this.projectForm.administrativeDistrictsId0 = JSON.parse(this.projectForm.administrativeDistrictsId); //行政区
          }
          this.projectForm.strengthGradeArr = JSON.parse(this.projectForm.strengthGrade)?.map(v => v.id); //强度等级
          this.projectForm.strengthGradece = JSON.parse(this.projectForm.strengthGrade);
          
          if (this.projectForm.performanceRate) {
            this.projectForm.performanceRateArr = JSON.parse(this.projectForm.performanceRate)?.map(v => v.id); //性能等级
          }
          if (this.projectForm.materialRequirements) {
            this.projectForm.materialRequirementsArr = JSON.parse(this.projectForm.materialRequirements)?.map(v => v.id); //材料要求
          }
          if (this.projectForm.specialRequirements) {
            this.projectForm.specialRequirementsArr = JSON.parse(this.projectForm.specialRequirements)?.map(v => v.id); //特殊要求
          }
          if (this.projectForm.otherRequirements) {
            this.projectForm.otherRequirementsArr = JSON.parse(this.projectForm.otherRequirements)?.map(v => v.id); //其他要求
          }
          if (this.projectForm.admixtureRequirements) {
            this.projectForm.admixtureRequirementsArr = JSON.parse(this.projectForm.admixtureRequirements)?.map(v => v.id); //外加剂要求
          }
          if (this.projectForm.pumpType) {
            const pumpType = JSON.parse(this.projectForm.pumpType);
            const arr = [];
            for (let i = 0; i < this.pumpTypeList.length; i++) {
              for (let j = 0; j < pumpType.length; j++) {
                if (pumpType[j].id === this.pumpTypeList[i].id) {
                  arr.push(pumpType[j].id);
                }
              }
            }
            this.projectForm.pumpTypeArr = arr;
          }
          if (this.projectForm.entrustBeginTime) {
            this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
          }
          if (this.projectForm.clearingForm) {
            this.projectForm.clearingForms = this.projectForm.clearingForm.split(",");
          }
          if (this.projectForm.qualityAgreementId) {
            this.projectForm.qualityAgreementIds = this.projectForm.qualityAgreementId.split(",");
          }
          if (this.projectForm.constructionStartDate) {
            this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
          }
          this.projectForm.firstIndateEndIndate = [this.projectForm.firstIndate, this.projectForm.endIndate];
          this.projectForm.list = res.data.list || [];
          const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
          this.oldFormData = JSON.parse(JSON.stringify(this.projectForm));
          const copyData = newData.filter(item => item.type == 1);
          this.servicePoint = copyData.map(item => item.name).join(",");
          //合同回显组装
          const Arry1 = [];
          for (let i = 0; i < res.data.fileFist?.length; i += 1) {
            if (res.data.fileFist[i].fileType === "1") {
              const data = {
                name: res.data.fileFist[i].fileName,
                fileName: res.data.fileFist[i].fileName,
                fileUrl: res.data.fileFist[i].path,
                path: res.data.fileFist[i].path,
                fileType: 1,
                createTime: res.data.fileFist[i].createTime,
                type: 1,
                id: res.data.fileFist[i].id,
              };
              Arry1.push(data);
            }
          }
          this.listFilesa1 = Arry1;
          if (this.projectForm.bulkDensities.length == 0) {
            this.projectForm.bulkDensities = [{ bulkDensity: "", strength: "", strengthId: "", type: "" }];
          }
        }
      });
      // 请求 2：获取管控业务等信息
      const p2 = getManagement({ id: id }).then(res => {
        if (res.data) {
          res.data.validityOfDelegationId *= 1;
          res.data.reportLogoId *= 1;
        }
        this.projectForm.riskInfo = res.data || {};
      });
      // 核心：返回 Promise.all 供外层 watch 继续等待
      return Promise.all([p1, p2]);
    },
    deleteFile1(index) {
      var removeFile = this.listFilesa1.splice(index, 1);
      if (removeFile[0].id) {
        removeFile[0].type = 0;
        this.listFilesa2.push(removeFile[0]);
      }
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess1(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.listFilesa1.push(params);
    },
    handleClose() {
      this.$emit("closeSubmit");
    },
    nextAction() {
      this.$emit("handleSure", this.projectForm);
      // alert(1)
    },
    /**验证 */
    chackForm() {
      if (!this.projectForm.discloseType) {
        this.$message.warning("交底类型不能为空");
        return;
      } else if (!this.projectForm.enginnerrName) {
        this.$message.warning("工程名称不能为空");
        return;
      } else if (this.projectForm.discloseType == 1 && !this.projectForm.delegationTypeId) {
        this.$message.warning("委托类型不能为空");
        return;
      }else if (!this.projectForm.enginnerrNatureId) {
        this.$message.warning("工程性质不能为空");
        return;
      } else if (!this.projectForm.enginnerrAddress) {
        this.$message.warning("工程地址不能为空");
        return;
      } else if (!this.projectForm.administrativeDistrictsId0 || !this.projectForm.administrativeDistrictsId0.length) {
        this.$message.warning("行政区不能为空");
        return;
      } else if (this.projectForm.poolFlag === "") {
        this.$message.warning("联营标识不能为空");
        return;
      } else if (this.projectForm.sidesFlag == 1 && !this.projectForm.affiliatedBranchId) {
        this.$message.warning("所属分公司不能为空");
        return;
      } else if (!this.projectForm.businessNatureId) {
        this.$message.warning("企业性质不能为空");
        return;
      } else if (!this.projectForm.coordinateNameId) {
        this.$message.warning("协调主体不能为空");
        return;
      } else if (!this.projectForm.coordinationSubjectId) {
        this.$message.warning("协调主体(建材)不能为空");
        return;
      } else if (!this.projectForm.collaborationUnit) {
        this.$message.warning("合同签订主体不能为空");
        return;
      } else if (!this.projectForm.regionalProjects && this.projectForm.regionalProjects != 0) {
        this.$message.warning("区域项目不能为空");
        return;
      } else if (!this.projectForm.businesNameId) {
        this.$message.warning("合同单位不能为空");
        return;
      } else if (!this.projectForm.effectiveDate && this.projectForm.discloseType == 2) {
        this.$message.warning("合同生效日期不能为空");
        return;
      } else if (!this.projectForm.firstIndateEndIndate?.length && this.projectForm.discloseType == 2) {
        this.$message.warning("合同有效期不能为空");
        return;
      } else if (!this.projectForm.modelOfContract) {
        this.$message.warning("合同模式不能为空");
        return;
      } else if (!this.projectForm.budgetPersonId) {
        this.$message.warning("预算员不能为空");
        return;
      } else if (!this.projectForm.sallerId) {
        this.$message.warning("销售员不能为空");
        return;
      } else if (!this.projectForm.firstLeader) {
        this.$message.warning("甲方项目负责人及权限不能为空");
        return;
      } else if (!this.projectForm.ourCompanyCheckPersonId) {
        this.$message.warning("我司合同签字人不能为空");
        return;
      } else if (!this.projectForm.firstPartySigner) {
        this.$message.warning("甲方小票签收人不能为空");
        return;
      } else if (this.projectForm.strengthGradeArr?.length == 0) {
        this.$message.warning("强度等级不能为空");
        return;
      } else if (!this.projectForm.qualityAgreementIds?.length) {
        this.$message.warning("质量约定不能为空");
        return;
      } else if (this.projectForm.pumpTypeArr?.length == 0) {
        this.$message.warning("泵送方式不能为空");
        return;
      } else if (!this.projectForm.enginnerrLiveDescription) {
        this.$message.warning("工程现场特性描述不能为空");
        return;
      } else if (!this.projectForm.isMainEngineering && this.projectForm.isMainEngineering !== 0) {
        this.$message.warning("是否主工程不能为空");
        return;
      } else if (!this.projectForm.wetherTrade && this.projectForm.wetherTrade !== 0) {
        this.$message.warning("是否贸易不能为空");
        return;
      }else if (this.projectForm.entrustBeginTImeEntrustEndTime?.length !== 2 && this.projectForm.discloseType == 1) {
        this.$message.warning("委托期不能为空");
        return;
      } else if (!this.projectForm.entrusNumber && this.projectForm.discloseType == 1) {
        this.$message.warning("委托量不能为空");
        return;
      } else if (!this.projectForm.placeTypeId) {
        this.$message.warning("销售处别不能为空");
        return;
      } else if (!this.projectForm.buseftPlaceTypeId) {
        this.$message.warning("预算处别不能为空");
        return;
      } else if (!this.projectForm.armorForMaterials && this.projectForm.armorForMaterials !== 0) {
        this.$message.warning("请选择甲供材料");
        return;
      } else if (!this.projectForm.invoiceCategory) {
        this.$message.warning("发票类别不能为空");
        return;
      } else if (!this.projectForm.taxRate) {
        this.$message.warning("税率不能为空");
        return;
      } else if (!this.projectForm.roadworkType) {
        this.$message.warning("合同单位类型不能为空");
        return;
      } else if (!this.projectForm.constructionCompany) {
        this.$message.warning("施工单位不能为空");
        return;
      } else if (!this.projectForm.constructionUnitId) {
        this.$message.warning("建设单位不能为空");
        return;
      } else if (this.projectForm.roadworkType == 3 && !this.projectForm.otherUnit) {
        this.$message.warning("其他单位不能为空");
        return;
      } else if (!this.projectForm.contractCompany) {
        this.$message.warning("委托单位不能为空");
        return;
      } else if (!this.projectForm.contractNo) {
        this.$message.warning("合同号不能为空");
        return;
      } else if (!this.projectForm.constructionStartDateConstructionEndDate?.length) {
        this.$message.warning("施工工期不能为空");
        return;
      } else if (!this.projectForm.qiRecord) {
        this.$message.warning("质监备案号不能为空");
        return;
      } else if (!this.projectForm.contractSumNumber && this.projectForm.discloseType == 2) {
        this.$message.warning("合同总量不能为空");
        return;
      } else if (!this.projectForm.contractPriceOfFax) {
        this.$message.warning("合同含税总价不能为空");
        return;
      } else if (!this.projectForm.buseftPlaceTypeId) {
        this.$message.warning("预算员处别不能为空");
        return;
      } else if (!this.projectForm.richAmount) {
        this.$message.warning("甲方有权对量不能为空");
        return;
      } else if (!this.projectForm.firstPartyMailbox) {
        this.$message.warning("甲方指定邮箱不能为空");
        return;
      } else if (!this.projectForm.secondPartyMailbox) {
        this.$message.warning("乙方指定邮箱不能为空");
        return;
      } else if (!this.projectForm.qualityAgreementIds) {
        this.$message.warning("质量约定不能为空");
        return;
      } else if (!this.projectForm.clearingForms?.length) {
        this.$message.warning("收款方式不能为空");
        return;
      } else if (!this.projectForm.circulateAgreed) {
        this.$message.warning("串换约定不能为空");
        return;
      } else if (!this.projectForm.visaAgreed) {
        this.$message.warning("签证约定不能为空");
        return;
      } else if (!this.projectForm.disclosureNotes) {
        this.$message.warning("交底备注不能为空");
        return;
      } else if (!this.projectForm.performanceRateArr?.length) {
        this.$message.warning("性能等级不能为空");
        return;
      } else if (!this.projectForm.materialRequirementsArr?.length) {
        this.$message.warning("材料要求不能为空");
        return;
      } else if (!this.projectForm.specialRequirementsArr?.length) {
        this.$message.warning("特殊要求不能为空");
        return;
      } else if (!this.projectForm.otherRequirementsArr?.length) {
        this.$message.warning("其他要求不能为空");
        return;
      } else if (!this.projectForm.admixtureRequirementsArr?.length) {
        this.$message.warning("外加剂要求不能为空");
        return;
      } else if (!this.projectForm.smallVolume.toString().trim()) {
        this.$message.warning("小方量约定不能为空");
        return;
      }
      // else if (!this.projectForm.ccContractNo && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('建委合同号不能为空');
      //   return
      // } else if (!this.projectForm.mainSupplySiteId && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('主供应站点不能为空');
      //   return
      // } else if (!this.projectForm.mainSupplySiteDistence && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('主供应站点距离不能为空');
      //   return
      // }
      let type = this.projectForm.bulkDensities.some(item => !item.strength || !item.bulkDensity);
      if (type) {
        this.$message.warning("约定容重不能为空");
        return;
      }
      return true;
    },
    /**
     * @Description: 保存 未处理权限问题
     * @Param:  基本交底信息、filedisAddCosts、产品与收费
     * @Author: wangwangwang
     */
    handleSave() {
      if (this.chackForm()) {
        this.saveBaseInfo();
      }
    },
    async saveBaseInfo() {
      /**
       * 保存基本交底信息
       * @param  {[type]} params1).then(( [description]
       * @return {[type]}                 [description]
       */
      // this.projectForm.fileFist = this.listFilesa1;
      this.projectForm.fileFist = [...this.listFilesa2, ...this.listFilesa1];
      if (this.projectForm.strengthGradeArr?.length > 0) {
        // console.log(this.projectForm.strengthGradeArr)
        this.projectForm.strengthGrade = JSON.stringify(
          this.projectForm.strengthGradeArr.map(v => {
            let obj = { id: v, name: this.strengthGradeList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      }
      if (this.projectForm.performanceRateArr?.length > 0) {
        this.projectForm.performanceRate = JSON.stringify(
          this.projectForm.performanceRateArr.map(v => {
            let obj = { id: v, name: this.performanceGradeList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.performanceRate = "";
      }
      if (this.projectForm.materialRequirementsArr?.length > 0) {
        this.projectForm.materialRequirements = JSON.stringify(
          this.projectForm.materialRequirementsArr.map(v => {
            let obj = { id: v, name: this.meterialRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.materialRequirements = "";
      }
      if (this.projectForm.specialRequirementsArr?.length > 0) {
        this.projectForm.specialRequirements = JSON.stringify(
          this.projectForm.specialRequirementsArr.map(v => {
            let obj = { id: v, name: this.specialRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.specialRequirements = "";
      }
      if (this.projectForm.otherRequirementsArr?.length > 0) {
        this.projectForm.otherRequirements = JSON.stringify(
          this.projectForm.otherRequirementsArr.map(v => {
            let obj = { id: v, name: this.otherRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.otherRequirements = "";
      }
      if (this.projectForm.admixtureRequirementsArr?.length > 0) {
        this.projectForm.admixtureRequirements = JSON.stringify(
          this.projectForm.admixtureRequirementsArr.map(v => {
            let obj = { id: v, name: this.admixtureRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.admixtureRequirements = "";
      }
      if (this.projectForm.pumpTypeArr?.length > 0) {
        this.projectForm.pumpType = JSON.stringify(
          this.projectForm.pumpTypeArr.map(v => {
            let obj = { id: v, name: this.pumpTypeList.find(v2 => v2.id == v)?.itemName, type: this.pumpTypeList.find(v2 => v2.id == v)?.type };
            return obj;
          })
        );
      } else {
        this.projectForm.pumpType = "";
      }
      this.projectForm.companyId = this.data.companyId;
      this.projectForm.company = this.data.company;
      if (this.projectForm.clearingForms?.length > 0) {
        this.projectForm.clearingForm = this.projectForm.clearingForms.join(",");
      } else {
        this.projectForm.clearingForm = "";
      }
      if (this.projectForm.qualityAgreementIds?.length > 0) {
        this.projectForm.qualityAgreementId = this.projectForm.qualityAgreementIds.join(",");
      } else {
        this.projectForm.qualityAgreementId = "";
      }
      if (this.projectForm.effectiveDate) {
        this.projectForm.effectiveDate = this.projectForm.effectiveDate.toString().length <= 7 ? this.projectForm.effectiveDate.toString() + "-01 00:00:00" : this.projectForm.effectiveDate.toString();
      }

      this.projectForm.administrativeDistrictsId = JSON.stringify(this.projectForm.administrativeDistrictsId0);
      this.projectForm.bulkDensities = [...this.bulkDensitiesDel, ...this.projectForm.bulkDensities];
      // updata属性为真是在工程履约中修改交底信息
      if (this.updata) {
        // console.log(this.listFilesa2, this.projectForm.fileList);
        this.projectForm.concreteContractNo = this.projectForm.concreteContractNo || "";
        this.projectForm.ccContractNo = this.projectForm.ccContractNo || "";
        await updateDisclose(this.projectForm)
          .then(res => {
            if (res.code === 1001) {
              this.nextAction();
              this.$message.success("交底信息保存成功");
              this.visible = false;
              this.$emit("closeSubmit", "save");
            }
          })
          .catch(() => {
            this.type = 0;
          });
      } else {
        await saveOrUpdateDisclose(this.projectForm)
          .then(res => {
            if (res.code === 1001) {
              this.nextAction();
              this.$message.success("交底信息保存成功");
              this.$emit("closeSubmit", "save");
            }
          })
          .catch(() => {
            this.type = 0;
          });
      }
    },
    /**
     * 校验委托交底参数 (单独抽取的方法)
     *  true-校验通过, false-校验失败或接口异常
     */
    checkDelegationParams() {
      return new Promise((resolve) => {
        if (!this.projectForm.delegationType && this.projectForm.delegationTypeId) {
          const selected = this.delegationTypeList.find(item => item.id === this.projectForm.delegationTypeId);
          if (selected) {
            this.projectForm.delegationType = selected.itemName;
          }
        }

        // 2. 构建请求参数
        const params = {
          entrusNumber: this.projectForm.entrusNumber,
          entrustBeginTime: this.projectForm.entrustBeginTime,
          entrustEndTime: this.projectForm.entrustEndTime,
          delegationTypeId: this.projectForm.delegationTypeId,
          delegationType: this.projectForm.delegationType,
          engineeringId: this.projectForm.engineeringId
        };
        // 3. 调用接口校验
        validateParameters(params).then(res => {
          if (res.code === 1001) {
            if (res.data.resultJudgment === '1001') {
              // 校验通过
              resolve(true);
            } else {
              // 校验不通过，提示后端返回的具体原因
              this.$message.warning(res.data.resultMsg );
              resolve(false);
            }
          } else {
            // 接口返回业务错误码
            this.$message.error(res.codeMsg);
            resolve(false);
          }
        })
      });
    },
    /**
     * @Description: 提交审核
     * @Param: 
     * @Author: wangwangwang
     */
    async handleSure() {
      if (!this.chackForm()) {
        return;
      }
      if (this.projectForm.discloseType == 1) {
        const isPass = await this.checkDelegationParams();
        if (!isPass) {
          return; // 校验不通过，终止后续操作
        }
      }
      await this.saveBaseInfo(); 
      await this.getDetail();
      const { executePhase } = this.data;
      this.$emit("closeSubmit");
      this.$router.push({
        name: "ProjectClarifiFlow",
        query: {
          formData: JSON.stringify({
            ...this.projectForm,
            entrustStatus: this.data.entrustStatus,
            contractStatus: this.data.contractStatus,
            oldFormData: this.oldFormData,
            sponsorCompany: this.UserInfo.companyId || this.UserInfo.userCompanyId,
          }),
          fileList1: JSON.stringify(this.listFilesa1),
          type: 1,
          companyId: this.data.companyId,
          company: this.data.company,
          executePhase,
        },
      });
    },
    // 提交审核前先保存一次数据
    // async handleSure() {
    //   if (this.chackForm()) {
    //     // if(this.data.entrustStatus === 0 && this.data.executePhase === 1 || this.data.executePhase === 4)
    //     await this.saveBaseInfo(); //保存
    //     //查询
    //     await this.getDetail();
    //     const { executePhase } = this.data;
    //     this.$emit("closeSubmit");
    //     this.$router.push({
    //       name: "ProjectClarifiFlow",
    //       query: {
    //         formData: JSON.stringify({
    //           ...this.projectForm,
    //           entrustStatus: this.data.entrustStatus,
    //           contractStatus: this.data.contractStatus,
    //           oldFormData: this.oldFormData,
    //           sponsorCompany: this.UserInfo.companyId || this.UserInfo.userCompanyId,
    //         }),
    //         fileList1: JSON.stringify(this.listFilesa1),
    //         type: 1,
    //         companyId: this.data.companyId,
    //         company: this.data.company,
    //         executePhase,
    //       },
    //     });
    //   }
    // },
    /**原物料单选列表查询 */
    ListChoicePagingFun() {
      rawMaterialsQueryPage(this.ListChoicePaging).then(res => {
        this.ListChoiceData = res.data.data;
        this.ListChoicePaging.total = res.data.totalRows;
      });
    },
    /**单选列表打开 */
    ListChoiceTypeFun(index, id) {
      this.ListChoiceType = true;
      this.ListChoiceDataIndex = index;
      if (id) {
        this.ListChoiceRadio = id;
        this.ListChoiceRadioCopy = id;
      } else {
        this.ListChoiceRadio = "";
        this.ListChoiceRadioCopy = "";
      }
      this.ListChoicePagingFun();
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        console.log(this.ListChoiceRadio + ";" + currentRow.id);
        let type = this.projectForm.list.findIndex(res => res.materialsId == currentRow.id);
        if (type == -1 || this.ListChoiceRadioCopy == currentRow.id) {
          this.ListChoiceRadio = currentRow.id;
          this.ListChoiceRadioRow = currentRow;
        } else {
          this.$message({
            message: "该选项已被选择！",
            type: "warning",
          });
          setTimeout(() => {
            this.ListChoiceRadioRow = "";
          }, 100);
        }
      }
    },
    /*表单*/
    addItem() {
      let data = {
        materialsId: "",
        materials: "",
        specification: "",
        mixingAmount: "0",
      };
      this.projectForm.list.push(data);
    },
    deleteItem(index) {
      this.projectForm.list.splice(index, 1);
    },
    /**保存和校验不重复选中项 */
    ListChoiceAddFun() {
      //原物料选择后对应值【品牌，规格..】带入表格中
      this.projectForm.list[this.ListChoiceDataIndex].materialsId = this.ListChoiceRadioRow.id;
      this.projectForm.list[this.ListChoiceDataIndex].materials = this.ListChoiceRadioRow.name;
      this.projectForm.list[this.ListChoiceDataIndex].specification = this.ListChoiceRadioRow.specification;
      this.ListChoiceType = false;
    },
    /* 获取预算员；销售员手机号 */
    changePhone(id, flag) {
      if (flag == "budgetPerson") {
        const budgetPersonPhone = this.budgetPersonIdList.filter(item => item.id == id);
        if (budgetPersonPhone && budgetPersonPhone.length > 0) {
          this.projectForm.budgetPersonPhone = budgetPersonPhone[0].phone;
        }
        return;
      }
      if (flag == "saller") {
        const sallerPhone = this.sallerIdList.filter(item => item.id == id);
        if (sallerPhone && sallerPhone.length > 0) {
          this.projectForm.sallerPhone = sallerPhone[0].phone;
        }
        return;
      }
    },
  },
  mounted() {},
};
</script>
<style lang="scss" src="./../project.scss" scoped></style>
<style lang="scss" scoped>
.checkbox-bg {
  margin: 0 10px 10px 10px;
  display: inline-block;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.pull-left {
  float: left;
}

.form-title {
  display: flex;
  justify-content: space-between;
}

.add-more {
  float: right;
}

.del-file {
  color: green;
  cursor: pointer;
}

.file-line {
  line-height: 2;
  border-bottom: 1px solid #ddd;
}

.text-danger,
.text-danger:focus {
  color: #ff5722;
}

.dialoginfo-title {
  > div {
    cursor: pointer;
    flex: 1;
  }
}
</style>
<style>
.display-row-Fzy {
  display: none;
}
.reference-project-box {
  margin: 15px; 
  .custom-form-item {
    display: flex;
    align-items: center;

    .custom-label {
      width: 160px;
      text-align: right;
      padding-right: 12px;
      box-sizing: border-box;
      font-size: 20px;
      color: #606266; 
    }

    .custom-content {
      flex: 1;
      max-width: 390px; 
      display: flex;

      .el-select {
        width: 100%; 
      }
    }
  }
}
</style>
